/**
 * Normaliza HTML o Texto plano que viene sin estructura (típico de leyes de provincias).
 * Si no detecta etiquetas de estructura (p, div, br), convierte los saltos de línea
 * en párrafos reales para una lectura prolija y exportación elegante.
 */
export function normalizeDocumentStructure(html: string): string {
  if (!html) return '';

  // Si ya tiene estructura de párrafos o divs, no tocamos demasiado para no romper tablas
  const hasStructure = /<(p|div|br|table|li)\b/i.test(html);
  
  if (hasStructure) {
    // Si tiene tablas pero no párrafos (común), envolvemos el texto suelto entre etiquetas
    return html;
  }

  // Si es texto plano o HTML sin etiquetas de bloque:
  // 1. Normalizamos saltos de línea múltiples
  let cleaned = html.trim()
    .replace(/\r\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n');

  // 2. Convertimos bloques separados por doble salto en párrafos
  const paragraphs = cleaned.split('\n\n')
    .map(p => p.trim())
    .filter(p => p.length > 0)
    .map(p => `<p>${p.replace(/\n/g, '<br>')}</p>`);

  return paragraphs.join('\n');
}
